import { NgModule } from '@angular/core';
import { DocumentComponent } from './document/document.component';
import { DocumentInlineComponent } from './document-inline/document-inline.component';
import { ExerciseComponent } from './exercise/exercise.component';
import { GalleryComponent } from './gallery/gallery.component';
import { HyperlinkComponent } from './hyperlink/hyperlink.component';
import { AudioComponent } from './audio/audio.component';
import { InteractionComponent } from './interaction/interaction.component';
import { SelfCheckExerciseComponent } from './selfcheck-exercise/self-check-exercise.component';
import { TeacherCommentComponent } from './teacher-comment/teacher-comment.component';
import { VideoComponent } from './video/video.component';
import { ZoomComponent } from './zoom/zoom.component';
import { CommonModule } from '@angular/common';
import { TextbookActionsBaseModule } from './@base/textbook-actions-base.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { LinkComponent } from './link/link.component';
import { CommonUtilityModule } from '../common-utility/common-utility.module';
import { ZoomDirectiveModule } from '../../external/zoom-directive/zoom-directive.module';

const components = [
  DocumentComponent,
  DocumentInlineComponent,
  ExerciseComponent,
  GalleryComponent,
  HyperlinkComponent,
  AudioComponent,
  InteractionComponent,
  SelfCheckExerciseComponent,
  TeacherCommentComponent,
  VideoComponent,
  ZoomComponent,
  NotFoundComponent,
  LinkComponent,
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [CommonModule, TextbookActionsBaseModule, CommonUtilityModule, ZoomDirectiveModule],
})
export class TextbookActionsInternalModule {}
